import React from "react";
import SecurityAuthView from "../../sections/security-auth";
import SocketInitialization from "src/SocketInitialization";
import useAutoLogoutSocket from "src/sockets/useAutoLogoutSocket";

const SecurityAuthPage: React.FC = () => {
  useAutoLogoutSocket();
  return (
    <>
      <SocketInitialization />
      <SecurityAuthView />
    </>
  );
};

export default SecurityAuthPage;
